import{useState as r}from"react";var t=function(t){void 0===t&&(t=!1);var n=r(t),o=n[0],e=n[1];return{on:o,toggle:function(){e(function(r){return!r})}}};export{t as default};
//# sourceMappingURL=index.js.map
